import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Components - imported
import { Avatar, Button } from '@material-ui/core';

// Icons
import AddAPhotoOutlinedIcon from '@material-ui/icons/AddAPhotoOutlined';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const AddTeamNames = ({
    slideform1, 
    setSlideForm1,
    handleGoBack,
    formData,
    onChange,
    is_create_page
}) => {

    const { team_1, team_2, search_tags } = formData;

    // Toggle the slideform state variable (go to next page in slide form)
    const todo = (e) => {
        setSlideForm1(!slideform1);
    }

    return (
        <div className="form-transition-element">

            {/* Display the heading */}
            {!is_create_page && (
                <div>
                    <h2>Create New Match</h2>
                </div>
            )}

            {/* Input for Team 1 */}
            <div className="modal__inputs" style={{flex:1, paddingLeft:'5px'}}>
                <h3>Team 1</h3>
                <input
                    type="text"
                    placeholder="Enter team name..."
                    className="input"
                    name="team_1"
                    maxlength="50"
                    style={{width: '94%'}}
                    value={team_1}
                    onChange={e => onChange(e)}
                />
                
                <h3>Team 2</h3>
                <input
                    type="text"
                    placeholder="Enter team name..."
                    className="input"
                    name="team_2"
                    maxlength="50"
                    style={{width: '94%'}}
                    value={team_2}
                    onChange={e => onChange(e)}
                />

                <h3>Search Tags (csv)</h3>
                <input
                    type="text"
                    placeholder="Enter search tags..."
                    className="input"
                    name="search_tags"
                    maxlength="50"
                    style={{width: '94%'}}
                    value={search_tags}
                    onChange={e => onChange(e)}
                />
            </div>

            <Button 
                disabled={!team_1?.length > 0 || !team_2?.length > 0}
                onClick={todo}
                variant="outlined" 
                className={`sidebar__tweet ${team_1?.length > 0 || team_2?.length > 0 ? 'black' : 'ghost'}`}
                fullWidth
            >
                Next
            </Button>

            <Button 
                onClick={(e) => handleGoBack(e)}
                variant="outlined" 
                className="sidebar__tweet heart"
                fullWidth
            >
                Go Back
            </Button>
        </div>
    )
}

AddTeamNames.propTypes = {

}

export default AddTeamNames
